import React from "react";
import CryptoList from "./CryptoList";
import "./InvestmentList.css";

function CryptoPage() {
  return (
    <div className="main-crypto-page-div">
      <CryptoList />
    </div>
  );
}

export default CryptoPage;
